import { Agente } from "./agente";
import { Cliente } from "./cliente";
import { Poliza } from "./poliza";

export class DatosToken {
    poliza!: Poliza;
	cliente!: Cliente;
    agente!: Agente;
    titulo!: string;
    textoDescripcion!: string;
    mostrarUploadDni!: boolean;
    dniObligatorio!: boolean;
    tipoOperacion!: string;
    
}